import { useHistory as scrivitoUseHistory } from "scrivito"
import { history as getHistory } from "shared/lib/browserHistory"

export function configureHistory(): void {
  const history = getHistory()
  if (!history) return

  scrivitoUseHistory(history)
}
